import { isEmpty } from '@backmarket/utils/object/isEmpty'

import { useFetchCMSPageContentWithFallback } from './useFetchCMSPageContentWithFallback'
import { useFetchFormattedPageContent } from './useFetchFormattedPageContent'
import { usePageParamsFromRoute } from './usePageParamsFromRoute'
import { useSetCMSPageCacheTagHeader } from './useSetCMSPageCacheTagHeader'

export async function useFetchCMSPageContent({
  fetchFallbackOnError,
}: {
  fetchFallbackOnError: boolean
}) {
  const pathParams = usePageParamsFromRoute()

  const { setCMSCacheTagHeader } = useSetCMSPageCacheTagHeader()

  const endpoint = isEmpty(pathParams.pageCategory)
    ? '/content/page/:pageType/:pageName'
    : '/content/page/:pageType/:pageName/:pageCategory'

  const response = fetchFallbackOnError
    ? await useFetchCMSPageContentWithFallback(endpoint, {
        pathParams,
      })
    : await useFetchFormattedPageContent(endpoint, {
        pathParams,
      })

  setCMSCacheTagHeader(response.data.value)

  return response
}
